import { render, staticRenderFns } from "./NomeCirculante.vue?vue&type=template&id=fb977a32&"
import script from "./NomeCirculante.vue?vue&type=script&lang=js&"
export * from "./NomeCirculante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports